


const WhyUs_AboutPillUp = () =>{
    return(
        <section className="py-10 px-3 md:px-[120px] relative bg-[#ffddb4]">
            <img className="absolute top-[-40px] h-24 sm:h-32 z-10 right-10" src="https://pillup.com/assets/Why%20Us/pillElement.png" alt="medicines" />
            <h2 className="text-gray-800 z-20 text-2xl md:text-5xl font-serif italic tracking-normal font-thin leading-[50px] md:leading-[99px] text-center">PillUp is a health tech company aimed at helping people in being punctual and independent in their medication.</h2>
        </section>
    )
}


export default WhyUs_AboutPillUp